import React from 'react';
import ReactDOM from 'react-dom';
import GameBoard from './App';
import './index.css';

ReactDOM.render(
  <GameBoard />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js